export default __webpack_public_path__ + "static/bordro-38f0d4742f70ffdfbaa202787aa40434.png";